// csvImport_Export.ts

import { getExportFilename } from "./xmlImport_Export";

/**
 * Exportiert den aktuellen Plan (CSV) als Download.
 *
 * @param csv      Inhalt der CSV-Datei als String
 * @param name     Plan-Name (z.B. aus data.settings.name)
 * @param modified Änderungsdatum/-zeit (z.B. aus data.settings.modified)
 */
export function exportPlanCsv(csv: string, name: string) {
  if (!csv) {
    alert("no Plan exists");
    return;
  }

  // Basis-Dateinamen vom XML-Export ableiten und Endung auf .csv setzen
  const filename = getExportFilename(name).replace(/\.xml$/, ".csv");

  // Blob aus dem CSV-Text erzeugen
  const blob = new Blob([csv], { type: "text/csv" });

  // Temporäre URL für den Blob erzeugen
  const url = URL.createObjectURL(blob);

  // Unsichtbaren <a>-Link erzeugen und Download auslösen
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();

  // Aufräumen: URL wieder freigeben
  URL.revokeObjectURL(url);
}

/**
 * Öffnet einen File-Picker, liest CSV ein und ruft onSuccess(csvText).
 * Analog zu importRulesXml (nur CSV statt XML).
 */
export function importPlanCsv(
  onSuccess: (csvText: string) => void,
  onError?: (msg: string) => void
) {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = ".csv,text/csv";
  input.onchange = (e: Event) => {
    const file = (e.target as HTMLInputElement).files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (ev) => {
      const text = (ev.target?.result ?? "") as string;
      if (!text || !text.trim()) {
        onError?.("Import failed: empty file");
        return;
      }
      onSuccess(text);
    };
    reader.readAsText(file);
  };
  input.click();
}